/* RESPONSIBLE TEAM: team-workflows */

// Custom workflow limits for specific high-volume workspaces
export const CUSTOM_WORKFLOW_LIMITS: Record<number | string, number> = {
  v7g38gws: 6000,
  qwum5ehb: 2000,
  w4slywic: 2000,
  u2d2x9ar: 1500,
  p8a06sgu: 1500,
};

export const DEFAULT_WORKFLOW_LIMIT = 1000;

export function getWorkflowLimit(appId: number | string | undefined): number {
  if (!appId) {
    return DEFAULT_WORKFLOW_LIMIT;
  }
  return CUSTOM_WORKFLOW_LIMITS[appId] ?? DEFAULT_WORKFLOW_LIMIT;
}

// Step limit per workflow — enforced on save to prevent performance degradation.
// Performance cliff observed around 600-630 steps (P50 jumps from ~2.3s to 16s+).
export const DEFAULT_STEP_LIMIT = 600;
export const STEP_LIMIT_BUFFER = 50;
export const STEP_LIMIT_WARNING_RATIO = 0.8;
export const STEP_LIMIT_NUDGE_RATIO = 0.3;
